exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contract_detail label{font-weight:700;margin-bottom:0}.mwp-100{max-width:100px}.mw-133{max-width:133px}.mw-200{max-width:200px}", ""]);

// exports
